import { useContext } from "react";
import { DictionaryContext, DictionaryProviderAPI } from "./DictionaryProvider";

const useDictionaryContext = (): DictionaryProviderAPI =>
  useContext(DictionaryContext);

export { useDictionaryContext };
